import { Injectable } from '@angular/core';
import { LoDialogService } from 'lo-design-system';
import { map, Observable } from 'rxjs';
import { AutoTopUpDialogComponent } from './auto-top-up-dialog.component';
import {
	AutoTopUpDialogData,
	AutoTopUpDialogResult
} from './auto-top-up-dialog.model';

@Injectable({ providedIn: 'root' })
export class AutoTopUpDialogService {
	constructor(private dialogs: LoDialogService) {}

	open(data: AutoTopUpDialogData): Observable<AutoTopUpDialogResult> {
		return this.dialogs
			.open<
				AutoTopUpDialogComponent,
				AutoTopUpDialogData,
				AutoTopUpDialogResult
			>(AutoTopUpDialogComponent, { data })
			.closed.pipe(map(result => result ?? { settings: null }));
	}
}
